import { render, staticRenderFns } from "./Spiral.vue?vue&type=template&id=5461490c&"
import script from "./Spiral.vue?vue&type=script&lang=js&"
export * from "./Spiral.vue?vue&type=script&lang=js&"
import style0 from "./Spiral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports